import { ReactNode } from 'react'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { filtrarGrupos, useListFilters } from '../../core/ListFiltersProvider'
import { ActiveFilter, ActiveFiltersBar, Input, TableFilter, TableFilters } from 'app/components'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Adicionar"). */
  actions?: ReactNode
}

// Sem debounce nem requisição: a busca filtra a lista já carregada (ver filtrarGrupos).
export const GruposListSearchComponent = ({ actions }: Props) => {
  const { responseSemPaginacao, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = filtrarGrupos(responseSemPaginacao, filters).length

  const activeFilters: ActiveFilter[] = filters.nome.trim()
    ? [
        {
          key: 'nome',
          label: 'Perfil',
          value: `“${filters.nome.trim()}”`,
          onRemove: () => setFilter('nome', ''),
        },
      ]
    : []

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar
          filters={activeFilters}
          onClearAll={clearFilters}
          summary={
            isLoading
              ? 'Buscando…'
              : `${total} ${total === 1 ? 'perfil encontrado' : 'perfis encontrados'}`
          }
        />
      }
    >
      <TableFilter label='Perfil' wide>
        <Input
          placeholder='Digite o nome ou a descrição'
          value={filters.nome}
          onChange={(e) => setFilter('nome', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
